<template>
  <v-container fluid>
    <PageHeading
      :text="'Страницы'"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-page-new'
          }"
        >
          <v-icon class="mr-2" small> mdi-plus </v-icon>
          Создать страницу
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridPages ref="grid" @copy-page="copyPageHandler" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridPages from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

import copyPageMutate from '@/services/gql/types/Pages/mutations/copyPage.gql'
import pageQuery from '@/services/gql/types/Pages/queries/page.gql'

export default {
  name: 'Pages',
  mixins: [gridPageInterface],
  components: {
    PageHeading,
    GridPages
  },
  metaInfo () {
    return {
      title: 'Страницы'
    }
  },
  methods: {
    async copyPageHandler (id) {
      await this.$async.copyPage.$perform({ id })
      await this.$refs.grid.refetch()
    }
  },
  apollo: {
    page: {
      query: pageQuery,
      fetchPolicy: 'network-only',
      variables (id) {
        return {
          where: {
            id
          }
        }
      }
    }
  },
  async: {
    copyPage (variables) {
      return this.$apollo.mutate({
        mutation: copyPageMutate,
        variables
      })
    }
  }
}
</script>
